export enum Indexes {
  OneYearLIBOR = "1 Year LIBOR",
  ThirtyDayAverageSOFR = "30-Day Average SOFR",
}
